import { render } from "./MessagePopup.vue?vue&type=template&id=00d4a786"
import script from "./MessagePopup.vue?vue&type=script&lang=js"
export * from "./MessagePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__